import React, { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { CAMPAIGN_CAPACITY, BANNER_WARN_PCT, BANNER_CRIT_PCT } from '../api/a2p.js';

// Yellow at ≥80%, red non-dismissible at ≥95%. Banner is per-session so
// if the admin dismisses it on this page reload it stays gone for the
// session, but reappears on the next.
export default function A2PCapacityBanner({ capacity, onCreate }) {
  const [dismissed, setDismissed] = useState(false);
  if (!capacity?.campaigns?.length) return null;

  const worst = capacity.campaigns.reduce(
    (acc, c) => (c.pct > acc.pct ? c : acc),
    { pct: -1 },
  );
  if (worst.pct < BANNER_WARN_PCT) return null;

  const isCrit = worst.pct >= BANNER_CRIT_PCT;
  const canDismiss = !isCrit;
  if (canDismiss && dismissed) return null;

  const colorCls = isCrit
    ? 'border-rose-500/70 bg-rose-500/15 text-rose-100'
    : 'border-amber-400/60 bg-amber-400/10 text-amber-100';

  const passcode = worst.passcode || '(unnamed)';
  return (
    <div role="alert" className={`flex items-start gap-3 p-4 rounded-md border ${colorCls}`}>
      <AlertTriangle className="w-5 h-5 mt-0.5 shrink-0" />
      <div className="flex-1">
        <div className="font-display font-bold text-sm">
          A2P campaign at {worst.used}/{CAMPAIGN_CAPACITY} numbers ({worst.pct}% capacity)
        </div>
        <div className="text-xs mt-1 opacity-90">
          Campaign <span className="font-mono">{passcode}</span> is approaching the per-campaign
          ceiling.{' '}
          {isCrit
            ? <strong>You'll be unable to attach new numbers to this campaign once it hits {CAMPAIGN_CAPACITY}.</strong>
            : 'Add a new A2P campaign so you can keep buying numbers without hitting the cap.'}
        </div>
        <div className="mt-3 flex items-center gap-2">
          <button
            onClick={onCreate}
            className="px-3 py-1.5 rounded-md bg-civix-purple/80 hover:bg-civix-purple text-white text-xs font-medium"
          >
            + Create A2P Campaign
          </button>
          {canDismiss && (
            <button
              onClick={() => setDismissed(true)}
              className="text-xs opacity-70 hover:opacity-100 inline-flex items-center gap-1"
            >
              <X className="w-3 h-3" /> Dismiss
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
